export default __webpack_public_path__ + "img/eaef35a2d13a8233a2730fb78ff9014d.svg";